<template>
  <div>
    <verbatim ref="verbatim" v-if="currentQuestion.data.type ===`verbatim`" @newAnswer="newAnswerChanged" @canValidate="canValidateChanged" />
    <multi-choice ref="multiChoice" v-else-if="currentQuestion.data.type ===`multiChoice`" @newAnswer="newAnswerChanged" @canValidate="canValidateChanged" />
    <single-choice ref="singleChoice" v-else-if="currentQuestion.data.type ===`singleChoice`" @newAnswer="newAnswerChanged" @canValidate="canValidateChanged" />
    <order ref="order" v-else-if="currentQuestion.data.type ===`order`" @newAnswer="newAnswerChanged" @canValidate="canValidateChanged" />
    <v-btn v-on:click.native="next" class="answers-buttom elevation-0 deep-purple accent-2 white--text" v-if="canValidate">
      Continuer
    </v-btn>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Verbatim from './Verbatim';
  import MultiChoice from './MultiChoice';
  import SingleChoice from './SingleChoice';
  import Order from './Order';

  export default {
    name: "Question",
    data: () => ({
      canValidate: false,
      currentAnswer: null,
    }),
    components: {
      Verbatim,
      MultiChoice,
      SingleChoice,
      Order,
    },
    computed: {
      ...mapState([
        `currentQuestion`,
        `currentSurvey`,
      ]),
    },
    methods: {
      newAnswerChanged (newAnswer) {
        this.currentAnswer = newAnswer;
      },
      canValidateChanged (canValidate) {
        this.canValidate = canValidate;
      },
      next () {
        this.$store.commit(`SET_ADDITIONAL_ANSWER`, this.currentAnswer);
        this.$refs[this.currentQuestion.data.type].clear();
        this.$emit(`next`);
        this.currentAnswer = null;
        this.canValidate = false;
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Question.vue?3620edf1